/// <amd-module name="Feed/Legacy/Protocols/Common/IPerson" />
export interface IPerson {
    /**
     * Person's email (optional)
     */
    email: string;
    /**
     * Person's Name
     */
    name: string;
    /**
     * Persons' Url
     */
    url: string;
}
